import { Component, OnInit, OnDestroy } from '@angular/core';
import { NodeService } from '../../services/node-service/node-service.service';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-add-pois',
  templateUrl: './view-add-pois.component.html',
  standalone: false,
})
export class ViewAddPoisComponent implements OnInit, OnDestroy {
  title: string = 'Agregar POIS';
  parentCategoryId: number = 0;
  subscription!: Subscription;
  isParentCategory: boolean = true;

  constructor(
    private nodeService: NodeService,
    private subcategoryService: SubcategoryService,
    private rootcategoriesService: RootcategoriesService
  ) {}

  ngOnInit(): void {
    let currentId = this.nodeService.getChildCategoryId();

    if (currentId === 0) {
      currentId = this.nodeService.getSubCategoryId();
    }

    if (currentId === 0) {
      currentId = this.nodeService.getCategoryId();
    }

    this.parentCategoryId = currentId;

    let parentCategory = this.nodeService.getParentSelected();

    if (!parentCategory) {
      this.subscription = this.subcategoryService.getCategory(currentId).subscribe({
        next: ({ body }) => {
          if (body.label === 'pois') {
            parentCategory = this.nodeService
              .getChildCategories()
              .filter((category) => category.id === currentId)[0];

            if (!parentCategory) {
              parentCategory = this.nodeService
                .getSubCategories()
                .filter((category) => category.id === currentId)[0];
            }

            if (!parentCategory) {
              parentCategory = this.nodeService
                .getCategories()
                .filter((category) => category.id === currentId)[0];
            }

            this.title = `${this.title} to ${parentCategory?.nombre}`;
          }
        },
        error: () => {
          this.rootcategoriesService.openSnacBar(
            'Ha ocurrido un error al buscar el Parent ID. Asegurese de que existe.'
          );
        },
      });
    }
    if (parentCategory) {
      this.title = `${this.title} to ${parentCategory.nombre}`;
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
